import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixLoyaltySocialmediaV1LoyaltySocialMediaUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    _: [
      {
        srcPath: '/_api/loyalty-social-media',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/loyalty-social-media',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/loyalty-social-media',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/loyalty-social-media',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/loyalty-social-media',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/loyalty-social-media',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_loyalty_social-media';

/**
 * Creates an entity for the specified account ID when the account follows a social media channel.
 *
 * Members can only follow enabled channels. A Wix user has to enable channels in the dashboard.
 *
 * >**Note:**
 * >This method requires [visitor or member authentication](https://dev.wix.com/docs/api-reference/articles/authentication/about-identities).
 */
export function createFollowedChannel(
  payload: object
): RequestOptionsFactory<any> {
  function __createFollowedChannel({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'followedChannel.createdDate' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.loyalty.socialmedia.v1.followed_channel',
      method: 'POST' as any,
      methodFqn:
        'wix.loyalty.socialmedia.v1.LoyaltySocialMedia.CreateFollowedChannel',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixLoyaltySocialmediaV1LoyaltySocialMediaUrl({
        protoPath: '/v1/followed-channels',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'followedChannel.createdDate' }],
          },
        ]),
    };

    return metadata;
  }

  return __createFollowedChannel;
}

/**
 * Retrieves a list of social media channels followed by the account. The list is ordered by creation date.
 *
 * >**Note:**
 * >This method requires [visitor or member authentication](https://dev.wix.com/docs/api-reference/articles/authentication/about-identities).
 */
export function listFollowedChannels(
  payload: object
): RequestOptionsFactory<any> {
  function __listFollowedChannels({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.loyalty.socialmedia.v1.followed_channel',
      method: 'GET' as any,
      methodFqn:
        'wix.loyalty.socialmedia.v1.LoyaltySocialMedia.ListFollowedChannels',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixLoyaltySocialmediaV1LoyaltySocialMediaUrl({
        protoPath: '/v1/followed-channels',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'followedChannels.createdDate' }],
          },
        ]),
    };

    return metadata;
  }

  return __listFollowedChannels;
}
